// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Redux:
import { setHasNotSeenVotdIntro } from 'actions/site'

class VersesInfoButton extends React.Component {
	componentDidMount() {
		const { hasSeenVotdIntro, history } = this.props

		if ( ! hasSeenVotdIntro ) {
			history.push( '/votd-info/' )
		}
	}

	render() {
		return (
			<div className="votd-page-info-button">
				<Link to="/votd-info/" className="button">More info</Link>
			</div>
		)
	}
}

export default connect()( VersesInfoButton )
